module.exports = __webpack_public_path__ + "img/dea-formazione-ico-religione.e15cbbb3.svg";